import React from 'react';
import { Hotel, Coffee, Bus, Waves, Users, Shield } from 'lucide-react';

const IncludedBenefits = () => {
  const included = [
    { icon: Hotel, title: 'Pousada', color: 'bg-cyan-500' },
    { icon: Coffee, title: 'Café da Manhã', color: 'bg-orange-500' },
    { icon: Bus, title: 'Ônibus Luxo', color: 'bg-red-500' },
    { icon: Waves, title: 'Tour + Praia', color: 'bg-teal-500' },
    { icon: Users, title: 'Guias', color: 'bg-purple-500' },
    { icon: Shield, title: 'Assistência 24h', color: 'bg-blue-500' }
  ];

  return (
    <section className="py-6 md:py-12 bg-white">
      <div className="container mx-auto px-3 sm:px-6 lg:px-8 max-w-7xl">
        <h2 className="text-lg md:text-2xl font-bold text-center text-gray-900 mb-3 md:mb-6">
          O que está <span className="text-red-600">incluso</span> no pacote
        </h2>
        
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-4">
          {included.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-2 md:p-4 shadow-md hover:shadow-lg transition-all duration-300 text-center border border-gray-100"
            >
              <div className={`w-8 h-8 md:w-12 md:h-12 ${item.color} rounded-lg flex items-center justify-center mx-auto mb-1 md:mb-3`}>
                <item.icon className="w-4 h-4 md:w-6 md:h-6 text-white" />
              </div>
              <p className="text-[10px] md:text-sm font-bold text-gray-900 leading-tight">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IncludedBenefits;
